module.exports = __webpack_public_path__ + "static/media/toilet.30406715.svg";